export default __webpack_public_path__ + "static/media/KanandaFerreira_06.870d2439.jpg";